import { PlatformRatingFormValues } from '../../pages/PlatformRating/PlatformRating.types'

export class SaveNPSPlatformMapper {
  public static toPersistence(data: PlatformRatingFormValues) {
    return {
      nota: data?.rating,
      comentario: data?.comment,
    }
  }
}
